// import store from '@state/store'

export default [
  {
    path: '/',
    name: 'home',
    component: () => lazyLoadView(import('@views/home/home.vue')),
    alias: '/home',
  },
  {
    path: '/services',
    name: 'services',
    component: () => lazyLoadView(import('@views/services/services.vue'))
  },
  {
    path: '/webinars',
    name: 'webinars',
    component: () => lazyLoadView(import('@views/webinars/webinars.vue'))
  },
  {
    path: '/clients',
    name: 'clients',
    component: () => lazyLoadView(import('@views/clients/clients.vue'))
  },
  {
    path: '/publishers',
    name: 'publishers',
    component: () => lazyLoadView(import('@views/publishers/publishers.vue'))
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => lazyLoadView(import('@views/contact/contact.vue'))
  },
  {
    path: '/trials',
    name: 'trials',
    component: () => lazyLoadView(import('@views/contact/contact.vue')),
    props: {
      video: new URL(location.href).searchParams.get('video') === '1',
    }
  },
  {
    path: '/404',
    name: '404',
    component: require('@views/error/_404.vue').default,
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
]

// Lazy-loads view components, but with better UX. A loading view
// will be used if the component takes a while to load, falling
// back to a timeout view in case the page fails to load. You can
// use this component to lazy-load a route with:
//
// component: () => lazyLoadView(import('@views/my-view'))
//
// NOTE: Components loaded with this strategy DO NOT have access
// to in-component guards, such as beforeRouteEnter,
// beforeRouteUpdate, and beforeRouteLeave. You must either use
// route-level guards instead or lazy-load the component directly:
//
// component: () => import('@views/my-view')
//
function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    // A component to use while the component is loading.
    loading: require('@views/loading/_loading.vue').default,
    // Delay before showing the loading component.
    // Default: 200 (milliseconds).
    delay: 400,
    // A fallback component in case the timeout is exceeded
    // when loading the component.
    error: require('@views/loading/_timeout.vue').default,
    // Time before giving up trying to load the component.
    // Default: Infinity (milliseconds).
    timeout: 10000,
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children)
    },
  })
}
